// The sections both settings pages share, in order, and the feature flags each lists, so
// a project's Settings tab and the team settings page read the same way.
import type { ProjectSwitch, SwitchCosts } from "../api/hooks/useAgentPortfolio";
import {
  clientSpecWarning,
  masterAgreementWarning,
  reviewerWarning,
  sppaWarning,
} from "./switchCostWarnings";

export const SECTION_TITLES = {
  runs: "Agents scheduled runs enabled",
  specialists: "Specialists",
  flags: "Feature flags",
  configs: "Agent configurations",
} as const;

export interface FeatureFlag {
  column: ProjectSwitch;
  title: string;
  describe: string;
  warning: (costs: SwitchCosts) => string;
}

export const FEATURE_FLAGS: FeatureFlag[] = [
  {
    column: "automated_review",
    title: "Automated reviewer",
    describe:
      "At the end of each nightly run, an auditor checks what the team changed, a rotating share of the project's earlier claims, and one specialist's record for gaps against the documents. What it confirms goes back to the owning agent as a review comment.",
    warning: reviewerWarning,
  },
  {
    column: "client_spec_clause_lists",
    title: "Documented obligations - Client building specification",
    describe:
      "The client's specification in Global data, such as Amazon's EUSDR, broken into its clauses and assessed on each project's Documented obligations cards.",
    warning: clientSpecWarning,
  },
  {
    column: "master_agreement_clause_lists",
    title: "Documented obligations - Master agreement",
    describe:
      "The client's framework contract in Global data that site contracts are signed under, such as Amazon's MSPPA, broken into its clauses and assessed by Legal on each project's Documented obligations cards.",
    warning: masterAgreementWarning,
  },
  {
    column: "sppa_clause_lists",
    title: "Documented obligations - SPPA",
    describe: "Each project's signed SPPA, broken into its clauses and assessed by Legal.",
    warning: sppaWarning,
  },
];
